export default ({ userObject, onlineUsers }) => {
  const [user] = onlineUsers.filter((user) => userObject.id === user.user.id);

  if (user) {
    return true;
  } else {
    return false;
  }
};
